$(function() {
    $('#form-consulting-field-date').datepicker({
        format: 'dd.mm.yyyy',
        language: 'de-DE'
    });
});


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/FormConsulting.js